import "@workspace/ui/globals.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";

declare const __INTERNAL_MOCK_DEVTOOLS_BYPASS_MD5__: string;

if (
	["mock", "mock-internal"].includes(import.meta.env.MODE) &&
	!import.meta.env.DEV
) {
	void import("disable-devtool").then(({ default: disableDevtool }) => {
		disableDevtool({
			clearLog: true,
			disableMenu: true,
			disableSelect: false,
			disableCopy: false,
			disableCut: false,
			disablePaste: false,
			interval: 500,
			md5: __INTERNAL_MOCK_DEVTOOLS_BYPASS_MD5__,
			tkName: "internal_qa",
			timeOutUrl: "about:blank",
		});
	});
}

const root = document.getElementById("root");
if (!root) {
	throw new Error("Missing #root element");
}
createRoot(root).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
